export const PAYMENT_PXPAY_REQUEST = 'PAYMENT_PXPAY_REQUEST';
export const PAYMENT_PXPAY_SUCCESS = 'PAYMENT_PXPAY_SUCCESS';
export const PAYMENT_PXPAY_FAILURE = 'PAYMENT_PXPAY_FAILURE';

export const WINDCAVE_PROCESS_PAYMENT_REQUEST = 'WINDCAVE_PROCESS_PAYMENT_REQUEST';
export const WINDCAVE_PROCESS_PAYMENT_SUCCESS = 'WINDCAVE_PROCESS_PAYMENT_SUCCESS';
export const WINDCAVE_PROCESS_PAYMENT_FAILURE = 'WINDCAVE_PROCESS_PAYMENT_FAILURE';

export const UPDATE_TOKEN_PAYMENT_REQUEST = 'UPDATE_TOKEN_PAYMENT_REQUEST';
export const UPDATE_TOKEN_PAYMENT_SUCCESS = 'UPDATE_TOKEN_PAYMENT_SUCCESS';
export const UPDATE_TOKEN_PAYMENT_FAILURE = 'UPDATE_TOKEN_PAYMENT_FAILURE';

export const PXPAY_REQUEST = 'PXPAY_REQUEST';
export const PXPAY_SUCCESS = 'PXPAY_SUCCESS';
export const PXPAY_FAILURE = 'PXPAY_FAILURE';

export const PAYMENT_TYPES_SUCCESS = 'PAYMENT_TYPES_SUCCESS';

export const GET_TOKENIZATION_REQUESTS_REQUEST = 'GET_TOKENIZATION_REQUESTS_REQUEST';
export const GET_TOKENIZATION_REQUESTS_SUCCESS = 'GET_TOKENIZATION_REQUESTS_SUCCESS';
export const GET_TOKENIZATION_REQUESTS_FAILURE = 'GET_TOKENIZATION_REQUESTS_FAILURE';

export const REQUEST_HPP_LINK_REQUEST = 'REQUEST_HPP_LINK_REQUEST';
export const REQUEST_HPP_LINK_SUCCESS = 'REQUEST_HPP_LINK_SUCCESS';
export const REQUEST_HPP_LINK_FAILURE = 'REQUEST_HPP_LINK_FAILURE';
